/*
fix for the Chrome bug where the browser doesn't scroll to anchor link on the initial page load.
Issue links: https://bugs.chromium.org/p/chromium/issues/detail?id=567218,
https://community.wpbeaverbuilder.com/t/anchor-links-to-another-page-not-working-in-chrome/10557
Also it is a fix for other browsers to scroll correctly to sections, that are under the registration widget:
during the load, the widget change its size, which causes the incorrect scroll to the anchor section.
*/

export const triggerHashScroll = () => {
    if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        window.location.hash = `_${hash}`;
        setTimeout(() => {
            window.location.hash = `#${hash}`;
        }, 1000);
    }
};
